module.exports = __webpack_public_path__ + "static/media/Barmag 7a3.2e8a0a97.jpg";